export default __webpack_public_path__ + "static/media/car-steering-wheel.f11e6e19.svg";